module.exports = __WEBPACK_EXTERNAL_MODULE_3__;


/*****************
 ** WEBPACK FOOTER
 ** external {"commonjs":"hammerjs","commonjs2":"hammerjs","root":"Hammer"}
 ** module id = 3
 ** module chunks = 0
 **/